import { render, staticRenderFns } from "./resHelp.vue?vue&type=template&id=1e77c08c&scoped=true&"
import script from "./resHelp.vue?vue&type=script&lang=js&"
export * from "./resHelp.vue?vue&type=script&lang=js&"
import style0 from "./resHelp.vue?vue&type=style&index=0&id=1e77c08c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e77c08c",
  null
  
)

export default component.exports